// extracted by mini-css-extract-plugin
export default {"video":"PlayVideo_video__yNRrQ"};